/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimePickerComponent } from './time-picker/time-picker.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { TimeDropdownComponent } from './time-dropdown/time-dropdown.component';
import { DateTimeWindowPickerComponent } from './date-time-window-picker/date-time-window-picker.component';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import * as langs from '../i18n/i18n';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FloatLabel } from 'primeng/floatlabel';
import { DatePicker } from 'primeng/datepicker';
import { Select, SelectModule } from 'primeng/select';
import { Button, ButtonDirective } from 'primeng/button';

@NgModule({
  imports: [
    Button,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DatePicker,
    SelectModule,
    TranslateModule,
    SharedComponentsModule,
    AutoCompleteModule,
    FloatLabel,
    DatePicker,
    Select,
    ButtonDirective,
  ],
  declarations: [DateTimePickerComponent, TimePickerComponent, TimeDropdownComponent, DateTimeWindowPickerComponent],
  exports: [DateTimePickerComponent, TimePickerComponent, TimeDropdownComponent, DateTimeWindowPickerComponent],
})
export class DateUtilsModule {
  constructor(private translateService: TranslateService) {
    Object.keys(langs).map((lang) => {
      translateService.setTranslation(lang, langs[lang], true);
    });
  }
}
